import { render, staticRenderFns } from "./myQuestionBank.vue?vue&type=template&id=2774c0e6&scoped=true&"
import script from "./myQuestionBank.vue?vue&type=script&lang=js&"
export * from "./myQuestionBank.vue?vue&type=script&lang=js&"
import style0 from "./myQuestionBank.vue?vue&type=style&index=0&id=2774c0e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2774c0e6",
  null
  
)

export default component.exports